<template>
    <vx-navbar class="mb-6">
        <template v-slot:left>
            <navbar-logo href="/"></navbar-logo>
        </template>

        <template v-slot:right>
            <vx-navbar-action>
                <vx-button size="sm" href="/login"> Login </vx-button>
            </vx-navbar-action>
        </template>
    </vx-navbar>
</template>

<script setup>
import { VxNavbar, VxNavbarAction, VxButton } from '@voxie/frontend-components';
import NavbarLogo from './NavbarLogo.vue';
</script>
